<template>
	<section>
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" :expand="false">
            <compFormQuery v-if="isQuery" class="margin-layout" :formdata="getBase" :value="formData" placeholder="--" ></compFormQuery>
            <compFormEdit v-else ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"></compFormEdit>
        </compWrapper>
		<compWrapper :title="$t('',{defaultValue:'换标信息'})" :expand="false">
			<compProduct class="margin-layout" ref="productlist" :baseData="formData" :querytype="type"></compProduct>
			<vButtonGroup slot="footer" v-if="!alertbox">
				<vButton v-for="item in getStatusBtns" :key="item.name" @click="item.run" :theme="item.theme">{{item.name}}</vButton>
			</vButtonGroup>
		</compWrapper>
		<compWrapper v-if="type==='query'" :title="$t('global.log.name',{defaultValue:'操作历史'})">
			<vTable class="margin-15" :columns="getLogColumns" :data="logList" border></vTable>
			<div class="text-right margin-right-15" v-if="alertbox">
				<vButton class="margin-left-10" v-for="item in getStatusBtns" :key="item.name" @click="item.run" :theme="item.theme" >{{item.name}}</vButton>
			</div>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { HttpMarkChangeOrderOutDetail } from '@/service/misc';
import { mapGetters } from 'vuex';
import compProduct from './product';

import mixin from "../mixin";

export default {
	mixins: [mixin],
	props: ['activeid', 'querytype', 'alertbox'],
	components: {
		compProduct,
	},
	data() {
		return {
			loading: false,
			type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
			formData: {
			},
			productList: [],
			attachList: [],
			logList: [],
		};
	},
	async created() {
        if(this.type == 'add') return
        this.getDetail()
	},
	computed: {
		...mapGetters('dictionary', ['getProductList', 'getOrgList', 'getCusproductList', 'getUserManageWarehouseList']),
		getStatus() {
			return this.type !== 'add' && this.formData.inboundPlanOrderStatus
		},
		isEdit() {
			return this.type === 'edit'
		},
		isQuery() {
			return this.type === 'query'
		},
		isAdd() {
			return this.type === 'add'
		},
		// 根据状态显示不同按钮
		getStatusBtns() {
			const getStatus = this.getStatus;
			const btn = [
                {
                    name: this.$t('global.common.return', { defaultValue: '返回' }),
                    show: !this.alertbox,
                    run: this.cancel
                },
                {
                    name: this.$t('fbb.inbound.save_draft', { defaultValue: '保存为草稿' }),
                    show: this.isAdd || (this.isEdit && getStatus == 0) || (getStatus == 6 && this.isEdit),
                    run: this.save
                },
                {
                    name: this.$t('fbb.inbound.submit_audit', { defaultValue: '提交审核' }),
                    show: (this.isAdd || (this.isEdit && getStatus == 0) || getStatus == 6) && this.perUpdate,
                    theme: 'primary',
                    run: this.submit
                },
                {
                    name: this.$t('fbb.alloment.cancel_audit', { defaultValue: "撤销审核" }),
                    show: (this.isQuery || (this.isEdit && getStatus == 0) || getStatus == 6) && this.perUpdate,
                    theme: 'primary',
                    run: this.submit
                },
			]
			return btn.filter(item => item.show);
		},
		getBase() {
			return [
                {
                    label: "换标下架单号",
                    key: 'changeLabelOrderNo',
                    query: true,
                },
                {
                    label: "单据状态",
                    tag: 'Select',
                    key: 'status',
                    options: this.getBillStatus2,
                    query: true,
                },
                {
                    label: "换标上架计划单号",
                    key: 'changeLabelPlanNo',
                    query: true,
                },
                {
                    label: this.$t("global.common.source_number", { defaultValue: "来源单号" }),
                    key: "sourceNo",
                    required: false,
                },
                {
                    label: this.$t("global.common.warehouse", { defaultValue: "仓库" }),
                    key: 'orgWarehouseId',
                    tag: 'vSelect',
                    options: this.getUserManageWarehouseList.map(item=>{
                        return {
                            label:item.label,
                            value:item.attach.id
                        }
                    }),
                    query: true,
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: "lineId",
                    tag: "Select",
                    options: this.getCusproductList.map((item) => {
                        return {
                            value: item.value,
                            label: item.attach.name,
                        }
                    }),
                    query: true,
                },
                {
                    label: this.$t('global.common.notes', { defaultValue: '备注' }),
                    tag: "Input",
                    key: "remark",
                    required: false,
                    props: {
                        type: 'textarea',
                        autosize: { minRows: 3, maxRows: 6 },
                        wrap: 'soft'
                    },
                    query: true,
                },
			];
		},
		getLogColumns() {
			return [
                {
                    title: this.$t('global.common.operator', { defaultValue: '操作人' }),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
                    key: 'opAction',
                    render: (h, { row }) => {
                        return this.getLogActions[row.operateType] || '';
                    },
                },
                {
                    title: this.$t('global.common.notes', { defaultValue: '备注' }),
                    key: 'remark',
                    width: "30%"
                },
                {
                    title: this.$t('global.common.operate_time', { defaultValue: '操作时间' }),
                    key: 'createdAt',
                },
            ];
		},
	},
	methods: {
        async getDetail(){
			this.loading = true;
            HttpMarkChangeOrderOutDetail({id: this.id}).then(res=>{
				this.loading = false;
                this.formData = res.data;
				this.logList = res.data.orderLogEntities;
            }).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
        },
		//保存为草稿
		async save() {
			const valid = await this.$refs.formbase.validate();
            console.log('valid',valid)
			if (!valid) return;
		},
		//保存提交
		async saveAndSubmit() {
			const valid = await this.$refs.formbase.validate();
            console.log('valid',valid)
			if (!valid) return;
		},

		//提交审核
		async submit() {
			if(this.isAdd || this.isEdit){
				const valid = await this.$refs.formbase.validate();
				if (!valid) return;
				if (this.isAdd) {
					return this.saveAndSubmit();
				}
			}

			this.loading = true;
			let array = []
			if (this.$refs.productlist.inboundPlanOrderPoItemList.length < 1) {
				array = this.$refs.productlist.proinblundList
			} else {
				array = this.$refs.productlist.inboundPlanOrderPoItemList
			}
			return HttpUpdateAndSubmitInboundBill({
				...this.formData,
				poNos: this.$refs.productlist.poNos,
				inboundPlanOrderItemModelList: this.$refs.productlist.dataList,
				inboundPlanOrderPoItemModelList: array,
				orderAttachModelList: this.$refs.attachlist.dataList,
			}).then(res => {
				this.cancel();
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});
		},
		cancel() {
			if (this.alertbox) {
				this.$emit('on-close')
			} else {
				this.$router.push({
					name: 'markChangeOut'
				})
			}
		},
	}
};
</script>
